export default "__VITE_ASSET__Ck_VkTNU__"